// src/layouts/Pages/PageHeader/CardHeaderColumns/items/documentHybrid.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { FileProtectOutlined, IdcardOutlined } from '@ant-design/icons';
import { parseCnpjToDisplay, parseCpfToDisplay, returnOnlyNumbers } from 'utils/helpers';
import translateX from 'utils/translateX';
import appService from 'services/appService';

// *******************************************************************************
// ITEM FUNCTION
// *******************************************************************************
export const cpfCnpjItem = record => {
  const isCompany = !!(record?.cnpj?.value || record?.foundedAt);
  const cpf = parseCpfToDisplay(record?.cpf?.value);
  const cnpj = parseCnpjToDisplay(record?.cnpj?.value);
  const documentValue = isCompany ? cnpj : cpf;
  const copyMessage = isCompany ? 'cnpj_copied' : 'cpf_copied';

  return {
    key: 'document',
    icon: isCompany ? <FileProtectOutlined /> : <IdcardOutlined />,
    label: documentValue,
    tooltipText: translateX(isCompany ? 'cnpj' : 'cpf'),
    tooltipPlacement: 'right',
    onClick: documentValue
      ? () => appService.handleCopyToClipboard(returnOnlyNumbers(documentValue), copyMessage)
      : null,
  };
};

export default cpfCnpjItem;
